import { getStoreValue } from '../../stores/store/utils';
import { stores } from '../../stores';
import { SportsLayout } from './types';

export const getSportsLayout = () => getStoreValue(stores.sports.userSettings)?.layout || SportsLayout.EUROPEAN;
